import { render, staticRenderFns } from "./RoundedElsaPenta.vue?vue&type=template&id=f78452f0&scoped=true&"
import script from "./RoundedElsaPenta.vue?vue&type=script&lang=js&"
export * from "./RoundedElsaPenta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78452f0",
  null
  
)

export default component.exports